var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.attachment)?_c('file-preview',{attrs:{"src":_vm.attachment.url,"name":_vm.attachment.fileName,"height":"200"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }